export default {
    namespaced: true,
    bookmarkCategory: {
        title: 'Categorías de marcador',
        name: 'Nombre',
        description: 'Descripción',
        color: 'Color',
        dispatchAlarm: 'Disparar alarma'
    }
}
